<template>
  <div class="share-box">
    <div ref="imgWrapper" class="picture-white">
      <div class="header">
        <div class="logo">
          <img src="@/assets/images/share_logo.png"/>
        </div>
        <div class="header-content">
          <div class="content-left">
            <div class="name">{{reportDetail.nickname}}</div>
            <div class="title">检测报告</div>
          </div>
          <div class="content-right">
            <img :src="headImg" crossOrigin="Anonymous"/>
          </div>
        </div>
      </div>
      <div class="main-box">
        <div class="remark">
          <div class="remark-title">健康名言：</div>
          <div class="remark-content">有规律的生活原是健康与长寿的秘诀。</div>
          <div class="remark-name">——巴尔扎克</div>
        </div>
        <div class="result-box">
          <div class="check-time">检测时间：{{reportDetail.checkTime}}</div>
          <div class="main-result">
            <div class="main-item"  v-for="(item,ind) in shareList.slice(0,4)" :key="ind">
              <div class="project-name">
                {{item.subText}}
                <img src="@/assets/images/tip_icon.png" v-if="item.levelsDesp!=1"/>
              </div>
              <div class="project-result" v-if="item.levelsDesp==1">{{levelCode[item.levelsDesp]}}</div>
              <div class="project-result abnormal" v-else>{{levelCode[item.levelsDesp]}}</div>
            </div>
          </div>
          <div class="other-result">
            <div class="tip-box">
              <img src="@/assets/images/tip_icon.png"/>
              请关注
            </div>
            <div class="other-content">
              <div class="center-point">
                <img src='@/assets/images/white-bgm.png'/>
                <div class="center-title">
                  <div class="subtitle">Detection Result</div>
                  <div>检测结果</div>
                </div>
              </div>
              <div class="surround-box">
                  <div :class="['circle' ,'circle'+ind]" v-for="(item,ind) in shareList.slice(4,14)" :key="ind">
                    <div class="surround-item">
                      {{item.subText}}
                      <img src="@/assets/images/tip_icon.png" v-if="item.levelsDesp!=1"/>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tip-content">检测报告仅作为健康管理的参考数据，不代表临床诊断。</div>
      </div>
      <div class="bottom-box">
        <div class="bottom-content">
          <div class="bottom-left">
            <div>
              <img src="@/assets/images/upload_img.png"/>
              德方云APP
            </div>
            <div>
              <img src="@/assets/images/wx_logo.png"/>
              德方云小程序
            </div>
          </div>
          <div class="bottom-right">
            <img src="@/assets/images/white_share.png"/>
            <!-- <div class="bottom-item">居家智慧体检</div>
            <div class="bottom-item">疾病自动预警</div>
            <div class="bottom-item">数据实时可视</div>
            <div class="bottom-item">辅助精准治疗</div> -->
          </div>
        </div>
        <div class="logo-title">德方智能体检机器人 坐享健康每一天</div>
      </div>
    </div>
    <div class="pre-box" style="background-image:url(https://dfosspic01.oss-cn-shenzhen.aliyuncs.com/dfcloud/pic/wechatpic/report_bgm.png)">
      <div class="mask">
        <div class="imgbox">
          <img :src='imgUrl'/>
          <div class="add-btn" @click='goBack()'>保存</div>
        </div>
      </div>
      <div class="list">
        <div class="user-mesg">
          <div class="user-box">
            <div class="sex">性别：{{reportDetail.sex}}</div>
            <div v-if="reportDetail.age!=0">年龄：{{reportDetail.age||''}}</div>
          </div>
          <div>检测设备：{{reportDetail.ctoolName||''}}</div>
          <div class="check-time">检测时间：{{reportDetail.checkTime||''}}</div>
        </div>
      </div>
      <div class="tab-box">
        <div class="tab-item"><span>健康提示</span></div>
        <div class="tab-item"><span>检测报告</span></div>
        <div class="tab-item" v-if="reportDetail.checkResultList.length!=0"><span>异常原因</span></div>
      </div>
      <div class="mains-box">
        <div id="text1">
          <div class="item">
            <div class="health-box">
              <div class="title">
                <div class="title-left">
                  健康提示
                </div>
              </div>
              <div class="content-box">
                <div class="content-item" v-for="(item,ind) in reportDetail.healthTipsList" :key='ind'>{{item}}</div>
              </div>
            </div>
          </div>
        </div>
        <div id='text2'>
        <div class="item">
          <div class="result-box">
            <div class="title">
              <div class="title-left">
                  检测报告
              </div>
              <div>
              </div>
            </div>
            <div class="result-content">
              <div class="result-item" v-for="(item,ind) in reportDetail.projectResltList" :key='ind'>
                <div class="item-name">{{item.projectName}}</div>
                <div :class="item.levelsDesp=='1'?'item-result':'item-result abnormal'">
                  <div class="relative">
                    {{levelCode[item.levelsDesp]}}
                  </div>
                </div>
              </div>
              <div class="report-tips"> 
                检测报告仅作为健康管理的参考数据，不代表临床诊断。
              </div>
            </div>
          </div>
        </div>
        </div>
        <div id='text3' v-if="reportDetail.checkResultList.length!=0">
        <div class="item">
          <div class="health-box">
            <div class="title">
              <div class="title-left">
                异常原因
              </div>
            </div>
            <div class="content-box">
              <div class="content-item" v-for="(item,ind) in reportDetail.checkResultList" :key='ind'>{{item}}</div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// downloadimg
import wx from 'weixin-js-sdk'
import html2canvas from "html2canvas"
import{ shareList,levelCode, shareBlackList } from '@/utils/diseaseConfig'
import { reqCheckRecordDetail, reqGetUserInfo } from '@/api/app'
import OSS, { base64ToFile } from '@/utils/oss';
export default {
  data(){
    return{
      imgUrl:'',
      dialogTableVisible:'',
      id:'',
      userId:'',
      reportDetail:{checkResultList:[],healthTipsList:[]},
      name:'',
      reportList:[],
      headImg:"",
      timer:''
    }
  },
  computed:{
    shareList:()=>shareList,
    levelCode:()=>levelCode,
    shareBlackList:()=>shareBlackList
  },
  methods:{
   async toImg() {
      const imgUrl = await html2canvas(this.$refs.imgWrapper).then(canvas => {
      let dataURL = canvas.toDataURL("img/png");
      return dataURL
      });
      if (imgUrl !== "") {
        // 
        this.imgUrl= imgUrl
        const file = base64ToFile(imgUrl,'share')
        const result = await OSS(file);
        // console.log(result)
        this.name = result.name
        // wx.miniProgram.redirectTo({ url: `/pages/UrineReport/index?id=${this.id}&userId=${this.userId}&url=${this.name}`});
      }
    },
    goBack(){
      wx.miniProgram.redirectTo({ url: `/pages/UrineReport/index?id=${this.id}&userId=${this.userId}&url=${this.name}`});
    },
    async getData(){
      const self = this;
      const postarr ={
        hcReportId:this.id,
        Authorization:this.$route.query.Authorization,
        tip:'图片生成中...'
      }
      await reqGetUserInfo({id:this.userId,Authorization:this.$route.query.Authorization,}).then(res=>{
        this.ImageToBase64(res.headImg)
      })
      reqCheckRecordDetail(postarr).then(res=>{
        console.log(res)
        if(res){
          this.reportDetail = res
          this.shareList.forEach((v,ind)=>{
            // te
            console.log(v)
            const reportItem = res.projectResltList.find(m=>m.projectName==v.subText)
            this.shareList[ind].levelsDesp = reportItem.levelsDesp
          })
          this.$nextTick(()=>{
            self.timer = setInterval(() => {
              if(self.headImg){
                self.toImg()
                clearInterval(self.timer)
              }
            }, 5);
          })
        }
      })
    },
    ImageToBase64( imageUrl ){
      //一定要设置为let，不然图片不显示
      let image = new Image();
      //解决跨域问题
      image.setAttribute('crossOrigin', 'anonymous');
      image.src = imageUrl
      //image.onload为异步加载
      image.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext('2d');
        context.drawImage(image, 0, 0, image.width, image.height);
        var quality = 0.8;
        //这里的dataurl就是base64类型
        var dataURL = canvas.toDataURL("image/jpeg", quality);//使用toDataUrl将图片转换成jpeg的格式,不要把图片压缩成png，因为压缩成png后base64的字符串可能比不转换前的长！
        this.headImg = dataURL
      }
    }
  },
  mounted(){
    this.id = this.$route.query.id
    this.userId = this.$route.query.userId
    console.log(this.userId,'userid')
    this.getData()
  }
}
</script>
<style scoped lang="scss">
.share-box{
  position: relative;
}
.pre-box{
  width: 100%;
  min-height: 100vh;
  background-color:#fff ;
  position: absolute;
  top: 0;
  left: 0;
  background-size: cover;
  height: 100%;
  overflow: hidden;
  .mask{
    position: absolute;
    width: 100%;
    background-color: rgba($color: #000000, $alpha: 0.6);
    height: 100%;
    z-index: 999;
    // display: none;
    .imgbox{
      width: 80%;
      top: 50px;
      left: 10%;
      position: absolute;
      img{
        border-radius: 20px;
        min-height: 80vh;
      }
      .add-btn{
        background-color: #00CDE5;
        width: 240px;
        text-align: center;
        color: #fff;
        font-size: 32px;
        padding: 16px 0;
        border-radius: 64px;
        line-height: 1.3;
        margin: 0 auto;
        margin-top: 20px;
      }
    }
  }
}
.picture-white{
  background: linear-gradient(200deg,#00d5bc 0%, #05c5da 100%);
  .header{
    height: 328px;
    .logo{
      width: 248px;
      height: 68px;
      margin: 0 auto;
      padding-top: 60px;
      img{
        display: block;
      }
    }
    .header-content{
      width: 686px;
      height: 176px;
      margin: 0 auto;
      margin-top: 24px;
      background-image: url(../assets/images/report_bgm.png);
      background-size: cover;
      display: flex;
      .content-left{
        margin-left: 32px;
        color: #ffffff;
        margin-right: 166px;
        .name{
          width: 336px;
          // height: 66px;
          font-size: 56px;
          font-weight: 700;
          line-height: 66px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding-top: 24px;
        }
        .title{
          font-size: 40px;
          line-height: 56px;
          margin-top: 6px;
        }
      }
      .content-right{
        width: 120px;
        height: 120px;
        border-radius: 50%;
        overflow: hidden;
        margin-top: 28px;
        img{
          display: block;
          width: 100%;
        }
      }
    }
  }
  .main-box{
    background-color: #ffffff;
    padding: 24px 32px;
    .remark{
      .remark-title{
        height: 40px;
        font-size: 28px;
        font-weight: 500;
        color: #00cde5;
        line-height: 28px;
      }
      .remark-content{
        font-size: 36px;
        // font-weight: 700;
        color: #333333;
      }
      .remark-name{
        font-size: 28px;
        text-align: right;
        margin-top: 10px;
      }
    }
    .result-box{
      .check-time{
        font-size: 24px;
        color: #999999;
        margin-bottom: 24px;
      }
      .main-result{
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        flex-wrap: wrap;
        .main-item{
          flex: 0 0 330px;
          // height: 88px;
          border: 1px solid #e6e6e6;
          border-radius: 8px;
          display: flex;
          justify-content: space-between;
          margin-bottom: 22px;
          justify-items: center;
          font-size: 28px;
          line-height: 88px;
          .project-name{
            margin-left: 24px;
            color: #666666;
            position: relative;
            img{
              position: absolute;
              display: block;
              width: 24px;
              height: 24px;
              top: 12px;
              right: -30px;
            }
          }
          .project-result{
            color: #46DAA8;
            margin-right: 24px;
          }
          .abnormal{
            color: #FE871B;
          }
        }
      }
      .other-result{
        position: relative;
        .tip-box{
          position: absolute;
          display: flex;
          align-items: center;
          font-size: 24px;
          color: #999999;
          top: 0;
          left: 0;
          line-height: 24px;
          img{
            display: block;
            width: 24px;
            height: 24px;
            margin-right: 8px;
          }
        }
        .other-content{
          position: relative;
          width: 100%;
          height: 508px;
          margin-left: 15px;
          .center-point{
            width: 408px;
            height: 408px;
            position: absolute;
            top: 50%;
            left: 50%;
            margin-left: -208px;
            margin-top: -208px;
            text-align: center;
            img{
              display: block;
            }
            .center-title{
              position: absolute;
              top: 50%;
              left: 50%;
              color: #FFFFFF;
              font-size: 28px;
              .subtitle{
                font-size: 24px;
              }
              transform: translate(-50%,-50%);
            }
          }
          .surround-box{
            position: absolute;
            top:  50%;
            left: 50%;
            width:  20px;
            height:  20px;
            margin-left: -10px;
            margin-top: -10px;
            border-radius: 50%;
          }
          .circle{
            position: absolute;
            top: 0;
            left: 0;
            .surround-item{
              white-space: nowrap;
              font-size: 28px;
              color: #666666;
              position: relative;
              img{
                position: absolute;
                display: block;
                width: 24px;
                height: 24px;
                top: -6px;
                right: -30px;
              }
            }
          }
          .circle0{
        /* rotateZ控制方向，每个元素旋转30度，12个元素刚好360度。translateY控制每个元素距中心点的距离 */
            transform: rotateZ(0) translateY(-244px) translateX(-20px);
           }
          .circle1{
            transform: rotateZ(39deg) translateY(-240px) translateX(30px);
            .surround-item{
              transform: rotateZ(-39deg);
            }
          }
          .circle2{
            transform: rotateZ(72deg) translateY(-234px);
            .surround-item{
              transform: rotateZ(-72deg);
            }
          }
          .circle3{
            transform: rotateZ(108deg) translateY(-224px);
            .surround-item{
              transform: rotateZ(-108deg);
            }
          }
          .circle4{
            transform: rotateZ(144deg) translateY(-214px);
            .surround-item{
              transform: rotateZ(-144deg);
            }
          }
          .circle5{
            transform: rotateZ(180deg) translateY(-214px) ;
            .surround-item{
              transform: rotateZ(-180deg) translateX(-40px);
            }
          }
          .circle6{
            transform: rotateZ(225deg) translateY(-250px);
            .surround-item{
              transform: rotateZ(-225deg) translateX(-60px);
            }
          }
          .circle7{
            transform: rotateZ(256deg) translateY(-288px);
            .surround-item{
              transform: rotateZ(-256deg) translateX(-34px);
            }
          }
          .circle8{
            transform: rotateZ(285deg) translateY(-288px);
            .surround-item{
              transform: rotateZ(-285deg) translateX(-66px);
            }
          }
          .circle9{
            transform: rotateZ(305deg) translateY(-288px);
            .surround-item{
              transform: rotateZ(-305deg) translateX(-66px);
            }
          }
        }
      }
    }
    .tip-content{
      font-size: 24px;
      color: #B3B3B3;
      line-height: 36px;
      padding-bottom: 24px;
      border-bottom: 2px dashed #B3B3B3;
    }
  }
  .bottom-box{
    background-color: #ffffff;
    padding: 24px 32px;
    .bottom-content{
      display: flex;
      justify-content: space-between;
      text-align: center;
      font-size: 18px;
      color: #333333;
      align-items: center;
      white-space: nowrap;
      .bottom-left{
        display: flex;
        justify-content: space-between;
        flex: 0 0 260px;
        &>div{
          flex: 0 0 114px;
        }
        img{
          display: block;
          width: 114px;
          height: 114px;
          margin: 0 auto;
        }
      }
      .bottom-right{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        flex: 0 0 400px;
        img{
          display: block;
          width: 100%;
        }
        .bottom-item{
          flex: 0 0 188px;
          // height: 44px;
          line-height: 46px;
          margin-bottom: 20px;
          border: 1px solid #00CDE5;
          text-align: center;
          border-radius: 74px;
          color: #666666;
          font-size: 26px;
          position: relative;
          // padding: 8px 0;
          height: 46px;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 190px;
          &:nth-child(2n-1):after{
            content: '';
            display: block;
            width: 8px;
            height: 8px;
            background-color: #00CDE5;
            border-radius: 8px;
            position: absolute;
            right: -14px;
            top: 18px;
          }
        }
      }
    }
    .logo-title{
      text-align: center;
      color: #00CDE5;
      font-size: 32px;
      padding-top: 20px;
    }
  }
}
.list{
  margin: 0 auto;
  // margin-bottom: 60px;
  .user-mesg{
    font-size: 32px;
    color: #ffffff;
    padding: 32px 0;
    border-bottom: 2px solid rgba(255, 255, 255, 0.6);
    margin: 0 32px;
    .user-box{
      display: flex;
      margin-bottom: 24px;
      .sex{
        margin-right: 32px;
      }
    }
    .check-time{
      margin-top: 24px;
    }
  }
}
.tab-box{
  display: flex;
  padding: 0 32px;
  color: #ffffff;
  font-size: 32px;
  padding-top: 36px;
  .tab-item{
    flex: 0 0 33%;
    // margin-right: 150px;
    line-height: 52px;
    padding-bottom: 26px;
    text-align: center;
    &:first-child{
      text-align: left;
    }
    &:nth-child(3){
      text-align: right;
    }
  }
  .active span{
    font-weight: 700;
    position: relative;
    &::before{
      content: '';
      display: block;
      width: 46px;
      height: 4px;
      background-color: #ffffff;
      position: absolute;
      left: 50%;
      margin-left: -23px;
      bottom: -23px;
    }
  }
}
.mains-box{
  width: 686px;
  margin: 0 auto;
  margin-top: 30px;
  margin-bottom: 90px;
 
  .item{
    background-color: #fff;
    border-radius: 12px;
    margin-bottom: 24px;
    padding: 32px;
    .title{
      font-size: 36px;
      display: flex;
      align-items: center;
      margin-bottom: 24px;
      justify-content: space-between;
      img{
        width: 64px;
        height: 64px;
        display: block;
        margin-right: 16px;
      }
      .title-left{
        display: flex;
        align-items: center;
      }
      .more{
        display: block;
        width: 48px;
        height: 48px;
      }
    }
    .content-box{
      font-size: 28px;
      color: #808080;
      line-height: 1.5;
      .content-item{
        margin-bottom: 16px;
        padding-bottom: 16px;
        border-bottom: 1 solid #f2f2f2;
        &:last-child{
          padding-bottom: 0;
          border: 0;
          margin-bottom: 0;
        }
      }
    }
  }
}
.result-box{
  .disease{
    white-space: nowrap;
    display: flex;
    height: 27px;
    .sub-title{
      color: #808080;
      font-size:28px;
      display: inline-block;
      padding-right: 10px;
      margin-right: 28px;
      padding-bottom: 3px;
      line-height: 1.3;
      position: relative;
      padding-top: 6px;
      img{
        display: block;
        width: 12px;
        height: 12px;
        position: absolute;
        right: -3px;
        top: 0;
      }
      &:last-child{
        margin-right: 0;
      }
    }
    .active{
      color: #00CDE5;
      font-size: 32px;
      position: relative;
      &::after{
        content: '';
        display: block;
        position: absolute;
        left: 50%;
        margin-left: -18px;
        bottom: 0;
        height: 4px;
        width: 36px;
        background-color: #00CDE5;
        bottom: 0;
      }
    }
  }
  .result-content{
    margin-top: 8px;
    .result-item{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 24px;
      padding-bottom: 6px;
      border-bottom: 1px solid #f2f2f2;
      line-height: 1.3;
      &:nth-last-child(2){
        border: 0;
      }
      .item-name{
        font-size: 28px;
        color: #666666;
        font-weight: 700;
      }
    }
    .item-result{
      font-size: 28px;
      color: #666666;
      font-weight: 500;
    }
    .relative{
      position: relative;
      img{
        width: 32px;
        height: 32px;
        position: absolute;
        right: 0;
        top: -16px;
      }
    }
    .abnormal{
      color: #DC3536;
      .relative{
        position: relative;
        padding-right: 32px;
        img{
          display: block;
        }
      }
    }
    .report-tips{
      font-size: 12px;
      color: #B3B3B3;
      margin-top: 17px;
      display: flex;
      align-items: center;
      img{
        width: 28px;
        height: 28px;
        display: block;
        margin-right: 8px;
      }
    }
  }
}
</style>